import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useLocation } from "react-router-dom";

const languages = [
  { code: "en", label: "EN" },
  { code: "fr", label: "FR" },
  { code: "de", label: "DE" },
  { code: "it", label: "IT" },
  { code: "pt", label: "PT" },
  { code: "es", label: "ES" },
];

interface LanguageSwitcherProps {
  variant?: "catalog" | "light";
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ variant = "catalog" }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { lang } = useParams<{ lang: string }>();
  const location = useLocation();

  const handleChange = (newLang: string) => {
    i18n.changeLanguage(newLang);
    if (lang) {
      // Replace current lang prefix with new one
      const newPath = location.pathname.replace(`/${lang}`, `/${newLang}`) + location.search;
      navigate(newPath, { replace: true });
    }
  };

  return (
    <div className="flex items-center gap-0.5">
      {languages.map((l) => (
        <button
          key={l.code}
          onClick={() => handleChange(l.code)}
          className={`px-2 py-1 text-[11px] font-sans font-medium rounded transition-all ${
            variant === "catalog"
              ? i18n.language === l.code
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:text-foreground"
              : i18n.language === l.code
                ? "text-[hsl(42,85%,52%)] font-bold"
                : "text-[hsl(0,0%,50%)] hover:text-[hsl(0,0%,80%)]"
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
